import { render, staticRenderFns } from "./ErrorForm.vue?vue&type=template&id=6b552914&scoped=true&"
import script from "./ErrorForm.vue?vue&type=script&lang=js&"
export * from "./ErrorForm.vue?vue&type=script&lang=js&"
import style0 from "./ErrorForm.vue?vue&type=style&index=0&id=6b552914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b552914",
  null
  
)

export default component.exports